const LOGO_URL = "https://customer-assets.emergentagent.com/job_precision-cookware/artifacts/dp89k0mx_Texstyle%20Logo.png";

export const Footer = () => {
  return (
    <footer 
      data-testid="footer"
      className="bg-black border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        {/* Row 1: Brand & Nav */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 mb-12">
          {/* Brand */}
          <div className="flex flex-col gap-3">
            <a 
              href="/" 
              data-testid="footer-logo"
              className="flex items-center gap-3"
            >
              <img 
                src={LOGO_URL} 
                alt="Tex-Style Company Bird Logo" 
                className="h-12 w-auto"
              />
              <span className="font-cormorant text-2xl text-white tracking-wide">
                Tex-Style Company
              </span>
            </a>
            <p className="font-raleway text-[11px] font-light uppercase tracking-[0.3em] text-tex-muted">
              Premium Kitchenware
            </p>
          </div>

          {/* Navigation */}
          <nav 
            data-testid="footer-nav"
            className="flex flex-wrap items-center gap-6 md:gap-8"
          >
            <a
              href="https://shop.texstyleco.com"
              data-testid="footer-collections"
              className="font-raleway text-[11px] font-semibold uppercase tracking-ultra text-tex-warm-white hover:text-tex-violet-bright transition-colors duration-300"
            >
              Collections
            </a>
            <a
              href="https://shop.texstyleco.com/collection/contact/"
              data-testid="footer-contact"
              className="font-raleway text-[11px] font-semibold uppercase tracking-ultra text-tex-warm-white hover:text-tex-violet-bright transition-colors duration-300"
            >
              Contact
            </a>
          </nav>
        </div>

        {/* Divider */}
        <div className="w-full h-[1px] bg-white/5 mb-8" />

        {/* Row 2: Copyright & Credits */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          {/* Copyright */}
          <p 
            data-testid="footer-copyright"
            className="font-raleway text-[11px] text-[#6B6B6B]"
          >
            Copyright © 2026 Tex-Style Company
          </p>

          {/* Credits */}
          <p className="font-raleway text-[11px] text-[#6B6B6B]">
            Designed by{' '}
            <a 
              href="https://autom8.digital" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-tex-violet-bright hover:text-tex-warm-white transition-colors duration-300"
            >
              Autom8
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
